import { z } from 'zod';
import type { PlatformEventType } from '../enums/p2p.js';
import type {
  FilePublishedV1, FileUnpublishedV1,
  TranscriptPublishedV1, TranscriptUnpublishedV1,
} from './p2p.events.js';

export type {
  P2PGroupTag,
  P2PTree,
  P2PSupplementalFile,
  P2PSupplementalFileProtocol,
} from './p2p.event.base.js';


export {
  FilePublishedV1, FileUnpublishedV1,
  TranscriptPublishedV1, TranscriptUnpublishedV1,
};

export const GenAIPlatformLinkedTenantSchema = z.object({
  tenant: z.object({
    identifier: z.string(),
    name: z.string(),
  }),
  account: z.object({
    identifier: z.string(),
    name: z.string(),
  }),
});

export type GenAIPlatformLinkedTenant = z.infer<typeof GenAIPlatformLinkedTenantSchema>;

export type P2PCommonMetadata = {
  eventIdentifier: string;
  tenantIdentifier: string;
  tenantAccountIdentifier: string;

  sentimentGroupId: number;
};


export type P2PEventSpecificMetadata<T extends PlatformEventType = PlatformEventType> = {
  [PlatformEventType.FilePublished]: FilePublishedV1.Metadata;
  [PlatformEventType.FileUnpublished]: FileUnpublishedV1.Metadata;
  [PlatformEventType.TranscriptPublished]: TranscriptPublishedV1.Metadata;
  [PlatformEventType.TranscriptUnpublished]: TranscriptUnpublishedV1.Metadata;
}[T];

export type P2PMessageData<T extends PlatformEventType = PlatformEventType> = {
  [PlatformEventType.FilePublished]: FilePublishedV1.Data;
  [PlatformEventType.FileUnpublished]: FileUnpublishedV1.Data;
  [PlatformEventType.TranscriptPublished]: TranscriptPublishedV1.Data;
  [PlatformEventType.TranscriptUnpublished]: TranscriptUnpublishedV1.Data;
}[T];

export type P2PMessageSupplementalFiles<T extends PlatformEventType = PlatformEventType> = {
  [PlatformEventType.FilePublished]: FilePublishedV1.SupplementalFiles;
  [PlatformEventType.FileUnpublished]: FileUnpublishedV1.SupplementalFiles;
  [PlatformEventType.TranscriptPublished]: TranscriptPublishedV1.SupplementalFiles;
  [PlatformEventType.TranscriptUnpublished]: TranscriptUnpublishedV1.SupplementalFiles;
}[T];

export type P2PMessageContent<T extends PlatformEventType = PlatformEventType> = {
  envelopeVersion: 1;
  createdAt: Date;
  messageId: string;
  eventType: T;
  metadata: {
    eventVersion: number;
  } & P2PCommonMetadata & P2PEventSpecificMetadata<T>;
  data: P2PMessageData<T>;
  supplementalFiles: P2PMessageSupplementalFiles<T>;
};